import { makeStyles } from '@material-ui/core/styles'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import styled from 'styled-components'
import { Box, Typography } from '@material-ui/core'
import { FC, ReactNode } from 'react'

const StyledNotificationsContainer = styled(Box)<{ isDevice: boolean }>`
  && .MuiFormControl-root {
    width: ${props => (props.isDevice ? '100%' : '808px')};
  }
  display: flex;
  width: 871px;
  padding: ${props => (props.isDevice ? '' : '0px 48px')};
  flex-direction: column;
  justify-content: center;
  gap: 1.25rem;
`

const HintTextBox = styled(Box)`
  width: 100% !important;
  margin-top: 12px;
`

const StyledHintText = styled(Typography)`
  overflow: hidden;
  color: ${props => props.theme.colors.accent};
  text-overflow: ellipsis;
  margin-bottom: 20px;
`
const hintText = "Setting the toggle to the 'opt-out' position will stop email updates."

const useStyles = makeStyles((isDevice: boolean) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    height: `${props => (props.isDevice ? 'auto' : '280px')}`,
    flexShrink: 0
  },
  textField: {
    textAlign: 'center',
    marginBottom: '8.5px',
    '& .MuiInput-underline:after': {
      borderBottom: 'none'
    }
  }
}))

interface NotificationsPageProps {
  children: ReactNode[]
}

export const NotificationsPage: FC<NotificationsPageProps> = props => {
  const { children } = props
  const classes = useStyles()
  const { isDevice } = useScreenSizes()

  return (
    <StyledNotificationsContainer className={classes.root} isDevice={isDevice}>
      <HintTextBox>
        <StyledHintText variant='caption'>{hintText}</StyledHintText>
      </HintTextBox>
      {children?.map(child => child)}
    </StyledNotificationsContainer>
  )
}
